import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteriesGrid');

    return {
        LOADING: t('loading'),
        NO_BATTERIES: t('noBatteries'),
        NO_MORE_BATTERIES: t('noMoreBatteries'),
        SEARCH_PLACEHOLDER: t('searchPlaceholder')
    };
};

export default useTranslation;
